import { ProjectConfigService } from './../../../model/services/api-services/project-config.service';
import { Project } from './../../../model/project';
import { ProjectConfigDialogService, PrjCfgShowParams } from './project-config-dialog.service';
import { SubscriptionMgr } from './../../../model/SubscriptionMgr';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ChangeDetectorRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TypedHandler } from 'app/types/handlers';
import { PrjSaveMessage } from '../project-save-dialog/project-save-entry.component';
import { ProjectConfig } from 'app/types/project-config';
import { ProjectsService } from 'app/model/services/api-services/projects.service';
import { ProjectConfigComponent } from 'app/components/project-config/project-config.component';
@Component({
  selector: 'app-project-config-dialog-component',
  templateUrl: './project-config-dialog.component.html',
  styleUrls: ['./project-config-dialog.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ProjectConfigDialogEntryComponent implements OnInit {
  private params?: PrjCfgShowParams;
  @ViewChild('config',{static:true}) config!:ProjectConfigComponent;
  public project?:Project;
  @Output() projectChange = new EventEmitter<Project>();
  public get updateHandler(): undefined | TypedHandler<PrjSaveMessage> {
    if (this.params && this.params.updateHandler) {
      return this.params.updateHandler;
    }
    return undefined;
  }
  constructor(private modal: NgbActiveModal,private prjService: ProjectsService,private cdr:ChangeDetectorRef) { }
  Show(params: PrjCfgShowParams) {
    this.params = params;
    if (!!this.params.projectId) {
      this.prjService.GetProject(this.params.projectId).then((response)=> {
        this.project = new Project(response.project);
       // this.config.project = this.project;
       this.cdr.detectChanges();
      });
    }
  }
  Hide() {
    this.modal.close();
  }
  ngOnInit(): void {
  }
  Refresh() {
    this.cdr.detectChanges();
  }

}
@Component({
  selector: 'app-project-config-dialog',
  template: ''
})
export class ProjectConfigDialogComponent implements OnDestroy {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr = new SubscriptionMgr();
  lastTitle: string | null = null;
  constructor(private modalService: NgbModal, private service: ProjectConfigDialogService) {

    this.subscriptionMgr.Subscribe(this.service.requests, (params: PrjCfgShowParams) => {
      this.modalRef = this.modalService.open(ProjectConfigDialogEntryComponent, { backdrop: 'static', modalDialogClass: 'project-config-dialog' });
      (this.modalRef.componentInstance as ProjectConfigDialogEntryComponent).Show(params);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }
}
